<template>
	<div class="form-content">
		<el-form ref="personForm" :model="personFormModel" :rules="personFormRules" label-width="140px">
			<el-form-item label="姓名：" prop="personName" class="form-item">
				<el-input v-model="personFormModel.personName" placeholder="请输入姓名"></el-input>
			</el-form-item>
			<el-form-item label="身份证号：" prop="idCard" class="form-item">
				<el-input v-model="personFormModel.idCard" placeholder="请输入身份证号"></el-input>
			</el-form-item>
			<el-form-item v-if="rylx !== '8'" label="证书等级：" prop="certificateSubName" class="form-item">
				<el-select v-model="personFormModel.certificateSubName" placeholder="请选择证书等级">
					<el-option label="A证" value="主要负责人（A类）"></el-option>
					<el-option label="B证" value="项目负责人（B类）"></el-option>
					<el-option label="C证" value="专职安全生产管理人员（C类）"></el-option>
					<el-option label="C1证" value="机械类专职安全生产管理人员（C1类）"></el-option>
					<el-option label="C2证" value="土建类专职安全生产管理人员（C2类）"></el-option>
					<el-option label="C3证" value="综合类专职安全生产管理人员（C3类）"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="证书类型：" prop="certificateName" class="form-item">
				<el-input v-model="personFormModel.certificateName" placeholder="请输入证书类型" readonly></el-input>
			</el-form-item>
			<el-form-item label="发证单位：" prop="makeUnit" class="form-item">
				<el-select v-model="personFormModel.makeUnit" placeholder="请选择发证单位">
					<!-- <el-option label="湖北省住房和城乡建设厅" value="湖北省住房和城乡建设厅"></el-option> -->
					<el-option label="湖北省安全生产监督管理局" value="湖北省安全生产监督管理局"></el-option>
					<el-option label="国家能源华中监管局" value="国家能源华中监管局"></el-option>
					<el-option label="其它发证机关" value="其它发证机关"></el-option>
				</el-select>
			</el-form-item>
			<el-form-item label="证书编号：" prop="certificateCode" class="form-item">
				<el-input v-model="personFormModel.certificateCode" placeholder="请输入证书编号"></el-input>
			</el-form-item>
			<el-form-item label="证书有效期：" prop="validityTime" class="form-item">
				<el-date-picker
					v-model="personFormModel.validityTime"
					type="date"
					placeholder="选择证书有效期"
					format="yyyy-MM-dd"
					value-format="yyyy-MM-dd"
					style="width: 100%;"
				></el-date-picker>
			</el-form-item>
		</el-form>
	</div>
</template>

<script>
	import { validateIdCard } from '@/utils/jr-validate'

	// 安许手动添加人员（不是湖北发证的人员在此进行手动添加）
	export default {
		name: 'ManuallyAdd',
		components: {},
		props: {
			// 人员类型（特种作业人员为：8）
			rylx: {
				type: String,
				default: ''
			}
		},
		data() {
			return {
				personFormModel: {
					// 姓名
					personName: '',
					// 身份证号
					idCard: '',
					// 证书类型
					certificateName: '',
					// 证书等级
					certificateSubName: '',
					// 发证单位
					makeUnit: '',
					// 证书编号
					certificateCode: '',
					// 证书有效期
					validityTime: ''
				},
				personFormRules: {
					personName: [{ required: true, message: '请输入姓名', trigger: ['blur'] }],
					idCard: [
						{ required: true, message: '请输入身份证号', trigger: ['blur'] },
						{ validator: validateIdCard, trigger: 'blur' }
					],
					certificateName: [{ required: true, message: '请输入证书类型', trigger: ['blur'] }],
					certificateSubName: [{ required: true, message: '请选择证书等级', trigger: ['change'] }],
					makeUnit: [{ required: true, message: '请输入发证单位', trigger: ['blur'] }],
					certificateCode: [{ required: true, message: '请输入证书编号', trigger: ['blur'] }],
					validityTime: [{ required: true, message: '请选择证书有效期', trigger: ['change'] }]
				}
			}
		},
		computed: {},
		watch: {
			rylx: {
				handler: function(newVal) {
					if (newVal === '8') {
						this.personFormModel.certificateName = '特种作业人员'
					} else {
						this.personFormModel.certificateName = '安全生产管理人员'
					}
				},
				immediate: true
			}
		},
		created() {},
		mounted() {},
		methods: {
			// 保存
			handleSaveManualAdd() {
				return new Promise((resolve, reject) => {
					this.$refs.personForm.validate(valid => {
						if (valid) {
							// 提交表单数据
							resolve(this.personFormModel)
						} else {
							console.log('error submit!!')
							reject(new Error('error submit!!'))
						}
					})
				})
			}
		}
	}
</script>

<style lang="scss" scoped></style>
